import { Navigate } from 'react-router-dom';
import { ROLES } from '../config/roles';

const ProtectedRoute = ({ element, allowedRoles }) => {
  const isAuthenticated = localStorage.getItem('token');
  const userRole = localStorage.getItem('role');

  console.log('ProtectedRoute Check:', { userRole, allowedRoles, path: window.location.pathname });

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  if (!allowedRoles.includes(userRole)) {
    if (userRole === ROLES.STAFF) {
      return <Navigate to="/current-atd" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }

  return element;
};

export const RedirectIfAuthenticated = ({ element }) => {
  const isAuthenticated = localStorage.getItem('token');
  const userRole = localStorage.getItem('role');

  if (!isAuthenticated) return element;

  if (userRole === ROLES.STAFF) {
    return <Navigate to="/current-atd" replace />;
  }
  return <Navigate to="/dashboard" replace />;
};

export default ProtectedRoute;